
import axios from "axios";

const signUp = (data) => {
  return axios.post("${process.env.REACT_APP_API_BASE_URL}/auth/signup", data).then((response) => {
    return response.data;
  });
};

const signIn = (email, password) => {
  return axios
    .post("${process.env.REACT_APP_API_BASE_URL}/auth/signin", {
      email,
      password,
    })
    .then((response) => {
      if (response.data) {
        localStorage.setItem("user", JSON.stringify(response.data.user));
        localStorage.setItem(
          "access_token",
          JSON.stringify(response.data.accessToken)
        );
      }

      return response.data;
    });
    
};

const logout = () => {

  
  return axios.post(`${process.env.REACT_APP_ADMIN_API_URL}/api/users/logout`,{data:localStorage.getItem("access_token"),userId:localStorage.getItem("user")} ).then((response) => {
    return response.data;
  });
};

const verifyAccount = (userId) => {
  return axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/confirmEmail?userId=${userId}`, ).then((response) => {

    return response.data;
  });
};

const resetPassword = (email) => {
  return axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/resetPassword`,{email: email} ).then((response) => {

    return response.data;
  });
};

const changePassword = (data) => {
  return axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/changePassword?token=${data.token}&userId=${data.userId}`,data ).then((response) => {

    return response.data;
  });
};

const isExistUser = (data) => {
  return axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/isExistUser`, data ).then((response) => {
    return response.data;
  });
};

export default {
  signUp,
  signIn,
  logout,
  verifyAccount,
  resetPassword,
  changePassword,
  isExistUser,
};
